import styled from 'styled-components';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const CustomEditor = styled.div`
  .rdw-editor-toolbar {
    background: transparent;
    max-width: 800px;
    font-size: 14px;
  }

  .rdw-editor-main {
    border: 1px solid #00000026;
    border-radius: 8px;
  }
  .public-DraftStyleDefault-block {
    padding: 0 12px;
  }

  .rdw-dropdown-wrapper {
    height: 20px;
  }
`;

export const AddButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 112px;
  margin: 3px 0;

  svg path {
    stroke: #383ecd;
  }
  p {
    color: #383ecd;
    margin-left: 4px;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  top: 0;
  align-items: center;
  margin-top: 0;
  padding-top: 32px;
  border-bottom: 1px solid #f4f4f4;
  padding: 14px 16px;
  background-color: ${COLOR_CONFIG['white-smoke']};
  border-radius: 12px;
`;

export const Body = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const BodyBorderContainer = styled.div<{ $color?: string }>`
  background-color: ${(props) => props.$color || COLOR_CONFIG.white};
  border: 1px solid ${(props) => props.$color || COLOR_CONFIG.white};
  border-radius: 12px;
`;

export const CustomSelect = styled.div`
  .dropdown-item {
    height: auto;
    background: ${COLOR_CONFIG.white};

    &:hover {
      background: ${COLOR.neutral['neutral-4']};
    }
  }
`;

export const LoggingMetric = styled.div`
  .dropdown {
    max-height: unset;
  }
`;

export const Grid_6 = styled.div`
  display: grid;
  grid-gap: 24px;
  padding-top: 12px;
  margin-bottom: 16px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
